import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { useTranslation } from "react-i18next";

const SwiperSlider = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="slide_wrap">
      <div className="banner_text_box">
        <div className="banner_text">{t("swiper.swiperText")}</div>
        {i18n.language === "en" ? (
          <div className="banner_text_sub">{t("swiper.swiperTextSub")}</div>
        ) : (
          ""
        )}
      </div>
      <Swiper
        // install Swiper modules
        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }} // autoplay 설정
      >
        <SwiperSlide className="swiper_slide">
          <div className="slide_image"></div>
        </SwiperSlide>
        <SwiperSlide className="swiper_slide">
          <div className="slide_image second"></div>
        </SwiperSlide>
        <SwiperSlide className="swiper_slide">
          <div className="slide_image third"></div>
        </SwiperSlide>
        <SwiperSlide className="swiper_slide">
          <div className="slide_image fourth"></div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default SwiperSlider;
